import styled from 'styled-components';

export const MobileSliderPagesStyled = styled.div`
    background-color: ${({ backgroundColor }: { backgroundColor?: string }) => backgroundColor || 'transparent'};
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
`;

const headerMinHeight = 48;
const headerMarginTop = 24;
const headerMarginBottom = 12;
export const mobileSliderHeaderHeight = headerMinHeight + headerMarginTop + headerMarginBottom;

export const MobileSliderPagesHeaderStyled = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    //overflow: hidden;
    position: relative;
    min-height: ${headerMinHeight}px;
    margin: ${headerMarginTop}px 16px ${headerMarginBottom}px;

    * {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const MobileSliderPagesHeaderContentStyled = styled.div`
    flex: 1;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: var(--color-label-primary);
`;

export const MobileSliderPagesHeaderCloseButtonContainerStyled = styled.div`
`;

export const MobileSliderPagesContentStyled = styled.div`
    padding: 12px 16px 0;
    position: relative;
    flex: 1;
    gap: 16px;
    display: flex;
    flex-direction: column;
`;
